import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { ComponentProps } from 'react';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { reactSelectBuiltins } from '@liveauctioneers/hammer-ui-core/select';
import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import styled from 'styled-components';

type Props = ComponentProps<typeof reactSelectBuiltins.MenuList> & { onCreateOption: () => void };

const MenuList = (props: Props) => {
    return (
        <>
            <reactSelectBuiltins.MenuList
                {...props}
                className="mobile:!max-h-[150px]"
                data-testid="menu-list"
            >
                {!props?.selectProps?.inputValue && (
                    <CustomBidSelectHeader>
                        <BodySecondary>
                            <ActionText
                                onClick={() => {
                                    props.selectProps?.onMenuClose();
                                    props?.onCreateOption?.();
                                }}
                            >
                                <FormattedMessage id="enterCustomBid" />
                            </ActionText>
                        </BodySecondary>
                    </CustomBidSelectHeader>
                )}
                {props.children}
            </reactSelectBuiltins.MenuList>
        </>
    );
};

export default MenuList;

const CustomBidSelectHeader = styled.div`
    padding: 8px 20px;
    h6 {
        font-size: 12px;
        letter-spacing: 1px;
    }
    button {
        text-transform: inherit;
        &:hover {
            text-decoration: underline;
        }
    }
`;
